import { agentService } from '../../helpers/services/agent.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  list: { data: [] },
  status: { list: true, save: true },
}

export const AGENT_MODULE = 'agent'

export const GET_AGENTS = 'getAgents'
export const CREATE_AGENT = 'createAgent'
export const UPDATE_AGENT = 'updateAgent'
export const DELETE_AGENT = 'deleteAgent'
export const SYNC_AGENTS = 'syncAgents'

const REQUESTING = 'requesting'
const LIST_SUCCESS = 'listSuccess'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'

function mapRow(a) {
  return {
    uuid: a.uuid,
    agentCode: a.agent_code,
    agentName: a.agent_name || a.name,
    name: a.name || a.agent_name,
    isActive: a.is_active === 'T' || a.is_active === true,
    // 'accounting' rows are mirrored from the ledger; 'local' rows are One Sales' own.
    source: a.source || 'accounting',
    syncedAt: a.synced_at || null,
  }
}

function fail(commit, error) {
  sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
  commit(FAILURE)
}

export const actions = {
  [GET_AGENTS]({ commit }, { search, isActive } = {}) {
    commit(REQUESTING, 'list')
    return agentService
      .getAgents(search, isActive)
      .then((result) => {
        commit(LIST_SUCCESS, result)
        commit(SUCCESS)
        return result
      })
      .catch((error) => fail(commit, error))
  },
  [CREATE_AGENT]({ commit }, { data }) {
    commit(REQUESTING, 'save')
    return agentService
      .createAgent(data)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.agent')]))
        commit(SUCCESS)
        return result
      })
      .catch((error) => fail(commit, error))
  },
  [UPDATE_AGENT]({ commit }, { uuid, data }) {
    commit(REQUESTING, 'save')
    return agentService
      .updateAgent(uuid, data)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.agent')]))
        commit(SUCCESS)
        return result
      })
      .catch((error) => fail(commit, error))
  },
  [DELETE_AGENT]({ commit }, { uuid, agentCode }) {
    commit(REQUESTING, 'save')
    return agentService
      .deleteAgent(uuid)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('agent.deleted', [agentCode || '']))
        commit(SUCCESS)
        return result
      })
      .catch((error) => fail(commit, error))
  },
  [SYNC_AGENTS]({ commit }) {
    commit(REQUESTING, 'save')
    return agentService
      .syncAgents()
      .then((result) => {
        const s = result?.data || {}
        sharedHelper.alertSuccessMessage(
          i18n.t('agent.syncResult', [s.inserted ?? 0, s.updated ?? 0, s.deactivated ?? 0, s.skipped ?? 0])
        )
        commit(SUCCESS)
        return result
      })
      .catch((error) => fail(commit, error))
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    state.list.data = (data.data || []).map(mapRow)
  },
  [FAILURE](state) {
    state.status = { list: true, save: true }
  },
  [REQUESTING](state, type) {
    state.status[type] = false
  },
  [SUCCESS](state) {
    state.status = { list: true, save: true }
  },
}
